import React, { useState } from 'react';
import Card from './Card';
import Rating from '../Rating/Rating';
import styles from './Card.module.css';
import BtnSwitch from "../Button/BtnSwitch";
import {saveRatingToLocal} from "../../services/RatingService";
import {useUser} from "../../contexts/UserContext";
import stylesSwitch from "../Button/BtnSwitch.module.css";

function CardRating({ lien, image, titre, rows, ratingFilledColor, ratingHoverColor = ratingFilledColor, ratingColor, ratingValue, onChange }) {
    const { user } = useUser();

    function renderContentBasedOnRole() {
        if (!user) return null;

        if (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) {
            return (
                <div className={styles.switchContainer}>
                    <Rating count={5} value={localRating} onChange={handleLocalRatingChange} color={ratingColor}
                            filledColor={ratingFilledColor} hoverColor={ratingHoverColor}/>
                </div>
            );
        } else if (user.roles.includes("ROLE_COACH")) {
            return null;
        }
    }

    const [localRating, setLocalRating] = useState(ratingValue);
    const handleLocalRatingChange = async (newRating) => {
        const rez = await onChange(newRating);
        if (rez.success) setLocalRating(newRating);
    };

    return (
        <Card lien={lien} image={image}>
            <>
                <h3 className={styles.cardTitle}>{titre}</h3>
                {rows.map((row, index) => (
                    <span key={index}>{row}</span>
                ))}
            </>

            { renderContentBasedOnRole() }

        </Card>
    );
}

export default CardRating;
